export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9654.3b364c00.jpg";